import React, { useContext } from 'react'
import { useQuery } from 'react-query'
import { DashboardContext } from '../Context/DashboardContext'
import AuthAxios from '../utils/AuthAxios'

const fetchAdminId = async (id) => {
    const response = await AuthAxios?.get(`/admin/detail/${id}`)
    const data = response.data.data
    return data
  }



export default function useSingleAdmin(id) {

    const {singleAdmin, setsingleAdmin} = useContext(DashboardContext);
      return useQuery('fetch single admin', ()=>fetchAdminId(id), {
        refetchOnWindowFocus: false ,
        onSuccess: (data) => {
            // console.log(data, "individual data")
           
            // setSingleuser(data);
           
            setsingleAdmin(data)
            
          },
      })
}
